import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { CtaSimple } from 'src/app/models/cta-simple';

@Component({
  selector: 'app-cta-simple',
  templateUrl: './cta-simple.component.html',
  styleUrls: ['./cta-simple.component.scss']
})
export class CtaSimpleComponent implements OnInit {

  @Input() ctaSimple:CtaSimple;
  @Input() isEdit:boolean = false;
  @Input() hasBack:boolean = false;
  @Output() ctaSimpleCtaClicked:EventEmitter<{content: CtaSimple}> = new EventEmitter();
  @Output() ctaSimpleforwardClicked:EventEmitter<{content: CtaSimple}> = new EventEmitter();
  @Output() backToTop = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  backToTopClicked(){
    this.backToTop.emit();
  }

  ctaClicked(){
    this.ctaSimpleCtaClicked.emit({content: this.ctaSimple});
  }

  forwardClicked(){
    this.ctaSimpleforwardClicked.emit({content: this.ctaSimple});
  }

  closeCta(){
    this.ctaSimpleforwardClicked.emit({content: this.ctaSimple});
  }
}